import { render, staticRenderFns } from "./unitDetail.vue?vue&type=template&id=ef89424a&scoped=true&"
import script from "./unitDetail.vue?vue&type=script&lang=js&"
export * from "./unitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef89424a",
  null
  
)

export default component.exports